export default [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
    meta: { title: '首页', requireAuth: true }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay.vue'),
    meta: { title: '支付', requireAuth: true }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test/test.vue'),
    meta: { title: '测试', requireAuth: true }
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('@/views/vip/vip.vue'),
    meta: { title: '会员权益', requireAuth: true }
  }
]
